<template>
  <div class="AccountAndProfileView">
    <PageHeader title="Dane konta" />
    <ShPageLayout>
      <AccountLayout>
        <template v-slot:profile>
          <UserProfile :user="editableUser" />
        </template>
        <template v-slot:client>
          <ClientData :user="user"
                      :client="client"
          />
        </template>
      </AccountLayout>
    </ShPageLayout>
  </div>
</template>

<script>
import { hDeepCopy } from '@/utils/helpers';
import ShPageLayout from '@/components/Helpers/ShPageLayout';
import PageHeader from '@/components/Common/PageHeader';
import AccountLayout from '@/components/Account/AccountLayout';
import UserProfile from '@/components/Users/UserProfile';
import ClientData from '@/components/Account/ClientData';

export default {
  name: 'AccountAndProfile',
  components: {
    PageHeader,
    ShPageLayout,
    AccountLayout,
    UserProfile,
    ClientData,
  },

  data() {
    return {
      editableUser: null,
      client: null,
    };
  },
  computed: {
    user() { return this.$store.getters['authorization/user']; },
  },

  created() {
    this.editableUser = hDeepCopy(this.user);
    this.client = this.editableUser.account;
    this.$EventBus.$on('UPDATE_USER_PROFILE', () => {
      this.editableUser = hDeepCopy(this.user);
    });
  },
};
</script>
